import { useCallback } from 'react';
import { setModalChanged, setModalScope, setModalType } from './scopeConfigurationSlice';
import { Scope, ScopeModalType } from './scopeUtilsLib';
import { AvailableModals, openModal } from '../../Modals/modalSlice';
import { useAppDispatch } from '../../../store';
import useIsConfigurationEditable from '../../../hooks/useIsConfigurationEditable';

export const useOpenScopeModal = (scope: Scope | undefined): (() => void) => {
  const isConfigurationEditable = useIsConfigurationEditable();
  const dispatch = useAppDispatch();

  return useCallback(() => {
    if (!isConfigurationEditable) return;

    dispatch(setModalScope(scope));
    dispatch(setModalType(ScopeModalType.EDIT));
    dispatch(setModalChanged(true));
    if (scope) {
      dispatch(
        openModal({
          type: AvailableModals.SCOPE_EDIT,
          data: {
            scopeId: scope.id,
          },
        }),
      );
    }
  }, [dispatch, isConfigurationEditable, scope]);
};
